import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import SpcPONumberState from "@tCentro/Store/Reducer/CenSpcPONumberState";
import { Draft } from "immer";

const initialState: SpcPONumberState = {
    SpcPONumber: "",
    SpcPONumberError: "",
    SpcshowFormErrors: false,
};
export default createTypedReducerWithImmer(initialState, {
    "Custom/SpcPONumber/SetSpcPONumber": (
        draft: Draft<SpcPONumberState>,
        action: { SpcPONumber: string },
    ) => {
        draft.SpcPONumber = action.SpcPONumber;
    },

    "Custom/SpcPONumber/SpcPONumberError": (
        draft: Draft<SpcPONumberState>,
        action: { SpcPONumberError: string },
    ) => {
        draft.SpcPONumberError = action.SpcPONumberError;
    },


    "Custom/SpcPONumber/SpcshowFormErrors": (
        draft: Draft<SpcPONumberState>,
        action: { SpcshowFormErrors: boolean },
    ) => {
        draft.SpcshowFormErrors = action.SpcshowFormErrors;
    },
});
